import React from "react";
import { pain } from "../data/content";
import { surface } from "../data/theme";
import { Punchline } from "./Punchline";
import { Reveal } from "./Reveal";
import { Section } from "./Section";
import { SectionTitle } from "./SectionTitle";
export function PainStatement() {
  return <Section labelledBy="pain-title" className="bg-white text-center" waveTo={surface.mist} data-id="element-166" data-mp="2rqt157012r9z">
      <Reveal data-id="element-167" data-mp="1v0tj8lxzmgeq">
        <SectionTitle id="pain-title" title={pain.title} highlight={pain.highlight} data-id="element-168" data-mp="1v1blq0b8tqv3" />
        <p className="mt-6 text-left leading-relaxed text-navy/80 sm:text-[17px]" data-id="element-169" data-mp="1z25a0usll7oi">{pain.text}</p>
        <Punchline text={pain.punchline} className="mt-6" data-id="element-170" data-mp="241hytl314otq" />
      </Reveal>
    </Section>;
}